import { Link } from "react-router";
import { LicensePanel } from "@/components/settings/license-panel";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useCountdownEnabled } from "@/hooks/use-preferences";
import { env } from "@/lib/env";
import { cn } from "@/lib/utils";
import { setCountdownEnabled } from "@/lib/preferences";

export function SettingsDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const countdown = useCountdownEnabled();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90dvh] overflow-y-auto sm:max-w-md" data-testid="settings">
        <DialogHeader>
          <DialogTitle>Settings</DialogTitle>
          <DialogDescription>Saved in this browser only.</DialogDescription>
        </DialogHeader>

        {env.adsEnabled && (
          <section className="space-y-3" aria-labelledby="settings-ads">
            <h3 id="settings-ads" className="text-sm font-semibold">
              Remove ads
            </h3>
            <LicensePanel />
          </section>
        )}

        <section
          className={cn("space-y-3", env.adsEnabled && "border-t border-border/50 pt-4")}
          aria-labelledby="settings-room"
        >
          <h3 id="settings-room" className="text-sm font-semibold">
            Rooms
          </h3>
          <div className="flex items-center justify-between gap-4">
            <div>
              <Label htmlFor="settings-countdown">Countdown before reveal</Label>
              <p className="mt-0.5 text-xs text-muted-foreground">
                The 3, 2, 1 in rooms that use it. Only affects your screen.
              </p>
            </div>
            <Switch
              id="settings-countdown"
              checked={countdown}
              onCheckedChange={setCountdownEnabled}
            />
          </div>
        </section>

        <p className="border-t border-border/50 pt-3 text-xs text-muted-foreground">
          <Link to="/privacy" onClick={() => onOpenChange(false)} className="hover:underline">
            Privacy
          </Link>
          {" · "}
          <Link to="/imprint" onClick={() => onOpenChange(false)} className="hover:underline">
            Imprint
          </Link>
        </p>
      </DialogContent>
    </Dialog>
  );
}
